import { Component, OnInit, Self } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { fromEvent } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { MY_FORMATS } from '@shared/constants/MY_FORMATS';
import { UnsubscribeService } from '@shared/services/unsubscribe.service';
import { PwaService } from '@core/services/pwa.service';
import {TranslateService} from "@ngx-translate/core";

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	providers: [
		{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
		{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
		UnsubscribeService
	]
})
export class AppComponent implements OnInit {

	constructor(
		private pwaService: PwaService,
		public translateSerivce: TranslateService,
		@Self() private onDestroy$: UnsubscribeService
	) {

	}

	public ngOnInit(): void {
		fromEvent(window, 'beforeinstallprompt').pipe(
			take(1),
			takeUntil(this.onDestroy$))
			.subscribe((event: any) => {
				event.preventDefault();
				this.pwaService.modalPwaEvent = event;
				this.pwaService.checkPlatform();
			});
		this.pwaService.checkPlatform();
	}
}


